import { IVersionsinfoResponse } from '../../models/ApiTypes';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ApiStore } from '../../stores/ApiStore';
import { bind, inject } from '../../utils/decorators';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';

@observer
export default class Portalinfos extends React.Component<RouteComponentProps<{}>, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @observable versionsinfo: IVersionsinfoResponse = [];

  async componentDidMount() {
    let versionsinfo = await this.apiStore.versionsinfo();
    if (versionsinfo.ok) {
      this.setVersionsinfo(versionsinfo.json);
    }
    let feVersionInfo = await this.apiStore.feVersionsInfo();
    if (feVersionInfo.ok) {
      this.setFeVersionTag(feVersionInfo.json.tag);
      if (feVersionInfo.json.tag === '' || feVersionInfo.json.tag === '-') {
        this.setFeBranch(feVersionInfo.json.branch, feVersionInfo.json.hash, feVersionInfo.json.date);
      }
    }
  }

  @bind @action setVersionsinfo(versionsinfo: IVersionsinfoResponse) {
    this.versionsinfo = versionsinfo;
  }

  @bind @action setFeVersionTag(versionTag: string) {
    this.versionsinfo.push({
      Komponente: 'Oberfläche',
      Version: versionTag
    });
  }

    // Auf nicht getaggten Versionen (Preproduction/Entwicklung) Infos zum Branch anzeigen
    @bind @action setFeBranch(branch: string, hash: string, date: string | undefined) {
      this.versionsinfo.push({
        Komponente: 'Branch',
        Version: branch
      });
      this.versionsinfo.push({
        Komponente: 'Hash',
        Version: hash
      });
      this.versionsinfo.push({
        Komponente: 'Datum',
        Version: date ? date : '-'
      });
  }

  render() {
    if (!this.versionsinfo || this.versionsinfo.length === 0) {
      return <div className="maxwidth">lade Versionsinformationen...</div>;
    }
    return (
      <div className="portalinfo maxwidth">
        <h2>Aktuelle Versionen</h2>
        {this.versionsinfo.map((eintrag, index) =>
          <div key={index}>
            <b>{eintrag.Komponente}:</b> {eintrag.Version}
          </div>
        )}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/Portalinfos.tsx